export const types = ['bom-trx', 'job-dashboard', 'design-transactions'] as const;
